import React from "react";
import NewsletterTen from "../component/NewsletterTen";

function NewsletterTenContainer() {
  return <NewsletterTen />;
}

export default NewsletterTenContainer;
